import React from 'react';
import {mapSettings} from 'config/consts';
import {MapContext, MapModes} from './MapPage.types';
import {getInitialLayers} from './helpers';

export const mapContext = React.createContext<MapContext>({
  layers: getInitialLayers(MapModes.default)(),
  showLayersPopup: false,
  toggleShowLayersPopup: () => null,
  centerOnUser: () => null,
  getMapElements: () => null,
  showEntitiesSearchPopup: false,
  toggleShowEntitiesSearchPopup: () => null,
  onSearchVehicles: () => null,
  mapSettings: {
    mapSettings,
    handleChangeMapSettings: () => null,
  },
  clusters: [],
  setLayers: () => null,
  setFilteredRoutes: () => null,
  agenciesFilters: {
    depots: [],
    departments: [],
    agencies: [],
  },
  setAgenciesFilters: () => null,
  setSelectedAgencies: () => null,
  setDetailsInfo: () => null,
  detailsInfo: null,
  mapRef: null,
  mapElements: null,
  filteredRoutes: [],
  selectedAgencies: [],
  routes: [],
  setRoutes: () => null,
  BCRegions: [],
  isBc: false,
  filteredVehicle: null
});
